import APIRequest from "./APIRequest";

// Admin User Management Services
export const getAllUsers = (params) => {
  return APIRequest.get(`admin/users`, params);
};

export const getUserById = (params) => {
  return APIRequest.get(`admin/users/${params.userId}`, params);
};

export const createUser = (params) => {
  return APIRequest.post(`/admin/create-user`, params);
};

export const updateUserService = (params) => {
  return APIRequest.put(`admin/users/${params.userId}`, params);
};

export const deleteUserService = (params) => {
  return APIRequest.delete(`admin/users/${params.userId}`, params);
};

export const blockUser = (params) => {
  return APIRequest.post(`admin/users/${params.userId}/block`, params);
};

export const unblockUser = (params) => {
  return APIRequest.post(`admin/users/${params.userId}/unblock`, params);
};

export const getUserActivity = (params) => {
  return APIRequest.get(`admin/users/${params.userId}/activity`, params);
};

export const bulkUpdateUsers = (params) => {
  return APIRequest.post(`admin/users/bulk-update`, params);
};

export const bulkDeleteUsers = (params) => {
  return APIRequest.post(`admin/users/bulk-delete`, params);
};

export const exportUsers = (params) => {
  return APIRequest.get(`admin/users/export`, params);
};